import React, { Component, Fragment } from 'react';
import { localize } from 'react-localize-redux';
import { connect } from 'react-redux';

import { PaymentStatus } from 'components/shared/StatusHelper';

import { List, AutoSizer } from 'react-virtualized';

import { toFriendlyDateString, humanizeSymbol, formatMoney } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';

class PaymentsTable extends Component {
  rowRenderer = ({ key, index, style }, data) => {
    const payments = data;
    let rowStyle = Object.assign({ borderBottom: `1px solid ${colors.LIGHT_GRAY}` }, style);

    return (
      <div
        id="mobile_card"
        key={key}
        style={rowStyle}
        onClick={() => this.props.toggleDialog(payments[index])}
      >
        <div className="row">
          <div className="mobile_header">
            {' '}
            <b style={{ fontFamily: 'Circular-Bold', textTransform: 'capitalize' }}>
              {humanizeSymbol(payments[index].payment_type)} {this.props.translate('payment')}
            </b>
          </div>
          <div style={{ float: 'right', marginTop: '4px' }}>
            <PaymentStatus status={payments[index].status} />
          </div>
        </div>
        <div className="row">
          <div className="mobile_subheader">
            {this.props.translate('dueOn')}{' '}
            {toFriendlyDateString(payments[index].due_date, {
              language: this.props.currentLanguage,
            })}
          </div>
        </div>
        <div className="row">
          <div className="mobile_subheader">
            {formatMoney(payments[index].amount_in_float)} {this.props.translate('due')}
          </div>
        </div>
        <div className="row">
          <div className="mobile_subheader">
            {formatMoney(payments[index].amount_outstanding_in_float)}{' '}
            {this.props.translate('outstanding')}
          </div>
        </div>
        <div className="row">
          <div className="mobile_subheader">
            <button
              type="button"
              className="link-button"
              onClick={() => this.props.toggleDialog(payments[index])}
              style={{ cursor: 'pointer' }}
            >
              {this.props.translate('viewPrintReceipt')}
            </button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const DEFAULT_ROW_HEIGHT = 125;
    const maxHeight =
      this.props.data.length > 3 ? 450 : this.props.data.length * DEFAULT_ROW_HEIGHT + 40;
    return (
      <Fragment>
        <div
          className="mobile_card"
          style={{ height: `${maxHeight}px`, padding: '15px', maxWidth: '900px', margin: 'auto' }}
        >
          <AutoSizer>
            {({ height, width }) => (
              <List
                rowCount={this.props.data.length}
                rowHeight={DEFAULT_ROW_HEIGHT}
                rowRenderer={({ key, index, style }) =>
                  this.rowRenderer({ key, index, style }, this.props.data)}
                width={width}
                height={height}
                style={{ borderTop: `5px solid ${AccentColor()}` }}
              />
            )}
          </AutoSizer>
        </div>
      </Fragment>
    );
  }
}

PaymentsTable = connect(state => ({
  currentLanguage: state.locale.currentLanguage,
}))(PaymentsTable);

export default localize()(PaymentsTable);
